// TODO: remove from `core-js@4` as withdrawn
require('../modules/esnext.object.iterate-entries');
require('../modules/esnext.object.iterate-keys');
require('../modules/esnext.object.iterate-values');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/object-iteration.js
// module id = 3210
// module chunks = 1